import { Fragment, useEffect, useRef } from 'react';
import { Modalprops } from './Modal.types';
import ModalError from './Modalerror';
import Icon from '../Icon/Icon';
import './Modal.css';

const Modal = ({ show, error, errorMessage, children, closeModal }: Modalprops) => {
  const dialogRef = useRef<HTMLElement>(null);
  const closeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!show) return;
    const previousFocus = document.activeElement as HTMLElement | null;
    document.body.classList.add('modal-open');
    closeRef.current?.focus();
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }
      if (event.key !== 'Tab' || !dialogRef.current) return;
      const focusable = Array.from(dialogRef.current.querySelectorAll<HTMLElement>('button, [href], [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.classList.remove('modal-open');
      document.removeEventListener('keydown', handleKeyDown);
      previousFocus?.focus();
    };
  }, [show, closeModal]);

  if (!show) return null;
  return (
    <div className="modal" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && closeModal()}>
      <section ref={dialogRef} className="modal-main" role="dialog" aria-modal="true" aria-labelledby="modal-title">
        <button ref={closeRef} type="button" className="modal-close" onClick={closeModal} aria-label="Cerrar"><Icon name="close" /></button>
        {error ? <ModalError text={errorMessage} closeModal={closeModal} /> : <><Fragment>{children}</Fragment><button type="button" className="lis-button lis-button--primary modal-primary-action" onClick={closeModal}>Cerrar</button></>}
      </section>
    </div>
  );
};

export default Modal;
